import { TableRow, TableCell, Skeleton } from '@mui/material';

// ----------------------------------------------------------------------

export default function SkeletonTable({ numOfColumns, ...other }) {
  return (
    <TableRow {...other}>
      {[...Array(numOfColumns)].map((_, index) => (
        <TableCell key={index}>
          <Skeleton variant="text" />
        </TableCell>
      ))}
    </TableRow>
  );
}
